import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Paper, Grid } from '@material-ui/core';
import LeadViewHeader from "./LeadViewHeader";
import LeadViewDtls from "./LeadViewDtls";
import RelatedData from "./RelatedData";
import UseFetchData from "../../../hooks/UseFetchData";

const LeadView = () => {
    const [LeadMainData, setLeadMainData] = useState([]);
    const [LeadNoteData, setLeadNoteData] = useState([]);
    const [LeadAttachData, setLeadAttachData] = useState([]);
    const [LeadImageData, setLeadImageData] = useState([]);
    const [LeadActivityData, setLeadActivityData] = useState([]);
    const location = useLocation();
    const [responseViewDtls, fetchViewDtls] = UseFetchData();

    const getViewDtlsData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("LeadID", location.state.LeadID);
        fetchViewDtls("Lead/View", bodyFormData);
    }

    useEffect(() => {
        if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
            setLeadMainData(responseViewDtls.Main);
        }
        if (responseViewDtls.LeadActivity !== undefined && responseViewDtls.LeadActivity.length > 0) {
            setLeadActivityData(responseViewDtls.LeadActivity);
        }
        if (responseViewDtls.LeadNotes !== undefined && responseViewDtls.LeadNotes.length > 0) {
            setLeadNoteData(responseViewDtls.LeadNotes);
        }
        if (responseViewDtls.LeadAttachments !== undefined && responseViewDtls.LeadAttachments.length > 0) {
            setLeadAttachData(responseViewDtls.LeadAttachments);
        }
        if (responseViewDtls.LeadImage !== undefined && responseViewDtls.LeadImage.length > 0) {
            setLeadImageData(responseViewDtls.LeadImage);
        }
    }, [responseViewDtls]);

    useEffect(() => {
        getViewDtlsData();
    }, []);

    return (
        <Paper >
            <LeadViewHeader
                LeadID={location.state.LeadID}
                LeadMainData={LeadMainData}
                PopulateData={getViewDtlsData}
            />
            <Grid container direction="row" style={{ marginTop: 7 }}>
                <Grid sm={8} xs={12}>
                    <Paper elevation={3} style={{ height: '100%' }}>
                        <LeadViewDtls
                            LeadID={location.state.LeadID}
                            LeadMainData={LeadMainData}
                        />
                    </Paper>
                </Grid>
                <Grid sm={4} xs={12}>
                    <Paper >
                        <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5, paddingLeft: 10 }}>RELATED</h2>
                        <RelatedData
                            LeadID={location.state.LeadID}
                            LeadMainData={LeadMainData}
                            LeadNoteData={LeadNoteData}
                            LeadAttachData={LeadAttachData}
                            LeadImageData={LeadImageData}
                            LeadActivityData={LeadActivityData}
                            PopulateData={getViewDtlsData}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default LeadView;
